import { USER_ROLES } from '../enums/UserRoles.enum';
import { INavigationItem } from '../interfaces/INavigationItem';
import { IUser } from '../interfaces/IUser';

export class NavigationOperations {
  /**
   * Filters navigation items based on user role, country, and contract type
   */
  public static filterByUser(items: INavigationItem[], user: IUser, isUserLoading = false): INavigationItem[] {
    if (isUserLoading) {
      return [];
    }

    return items.filter((item: INavigationItem) => {
      if (!item.permissions.includes(user.role)) {
        return false;
      }
      if (item.countries?.length && !item.countries.includes(user.country)) {
        return false;
      }
      if (item.contractTypes?.length && !user.isTimekeeper && !item.contractTypes.includes(user.contractTypeName)) {
        return false;
      }
      if (item.isTvInOrgChartRequired && user.role === USER_ROLES.BUDGETVERANTWORTLICHER && !user.hasTvInOrgChart) {
        return false;
      }
      if (item.isServiceLineTaskAccessRequired && user.role !== USER_ROLES.TECHNISCHER_CONTROLLER && !user.isMemberOfServiceLanePool) {
        return false;
      }
      return true;
    });
  }
}
